import { createReducer } from '@reduxjs/toolkit';
import { TagShape } from './model';
import * as tagActions from './actions';
import * as appActions from '../app/actions';
import * as lastStateActions from '../lastState/actions';

const initial: TagShape = {
  tags: [],
  selectedIds: [],
  expandedMode: false,
  loading: false,
};

export const tagReducer = createReducer<TagShape>(initial, (builder) =>
  builder
    .addCase(tagActions.tagsChanged, (s, a) => {
      s.tags = a.payload.tags;
    })
    .addCase(tagActions.tagsSelected, (s, a) => {
      s.selectedIds = a.payload.ids;
    })
    .addCase(appActions.resetFilters, (s) => {
      s.selectedIds = [];
    })
    .addCase(tagActions.expandedModeChanged, (s, a) => {
      s.expandedMode = a.payload.expandedMode;
    })
    .addCase(tagActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      if (a.payload) {
        s.selectedIds = a.payload.state.data.tag.selectedIds;
        s.expandedMode = a.payload.state.data.tag.expandedMode;
      } else {
        s.selectedIds = initial.selectedIds;
        s.expandedMode = initial.expandedMode;
      }
    }),
);
